import { createClient } from '@supabase/supabase-js';

// Supabase configuration
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables');
}

// Create Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

/**
 * Save email capture to Supabase
 * @param {Object} data - Email capture data
 * @returns {Promise<Object>} Result with success status and data/error
 */
export async function saveEmailCapture(data) {
  try {
    const { data: result, error } = await supabase
      .from('email_captures')
      .insert([
        {
          email: data.email,
          primary_app: data.primaryApp,
          secondary_apps: data.secondaryApps || [],
          source: data.source || 'benchmark_result',
          timestamp: data.timestamp || new Date().toISOString(),
          user_agent: navigator.userAgent
        }
      ])
      .select();

    if (error) {
      console.error('Supabase error:', error);
      return { success: false, error: error.message };
    }

    return { success: true, data: result };
  } catch (err) {
    console.error('Error saving email capture:', err);
    return { success: false, error: err.message };
  }
}

/**
 * Check if email already exists in database
 * @param {string} email - Email to check
 * @returns {Promise<boolean>} True if email exists
 */
export async function checkEmailExists(email) {
  try {
    const { data, error } = await supabase
      .from('email_captures')
      .select('email')
      .eq('email', email.toLowerCase())
      .limit(1);

    if (error) {
      console.error('Error checking email:', error);
      return false;
    }

    return data && data.length > 0;
  } catch (err) {
    console.error('Error checking email:', err);
    return false;
  }
}
